import { render, staticRenderFns } from "./by-ba-reports.vue?vue&type=template&id=076fa24b&lang=pug&"
import script from "./by-ba-reports.vue?vue&type=script&lang=js&"
export * from "./by-ba-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports